<script>
  export default {
    name: 'Modal',
    props: ['next', 'sign', 'accept', 'name'],
    data() {
      return {
        isModalVisible: false,
        //nextURL: "",
        //signURL: "",
        //acceptURL: "",
      }
    },
    methods: {
      closeYes() {
        let tmpYURL = this.next;
    	const csrfToken = document
      	   .querySelector('meta[name="csrf-token"]')
           ?.getAttribute('content')

    	fetch(this.sign, {
      	   method: 'POST',
           headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken
     	   },
      	   credentials: 'include',
      	   body: JSON.stringify({ sign: true })
    	})
      	   .then(res => {
              if (!res.ok) throw res
              window.location.href = tmpYURL
      	   })
      	   .catch(err => {
              console.error('Request failed', err)
           })
        this.$emit('close');
      },
      closeNo() {
        this.$emit('close');
      }
    },
  };
</script>

<template>
  <div class="modal" tabindex="-1" role="dialog" style="display:block;">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body" style="color:black;text-align:center;">
          <slot name="body">
          {{ $t('javascript.modal.would_you_like_to') }}
          <h1 style="font-family: Ephesis, Regular;">{{name}}</h1>
          </slot>
         </div>

        <div class="modal-footer justify-content-center" style="text-align: center;">
          <button
            type="button"
            class="btn btn-primary btn-nomargin"
            @click="closeYes"
          >
            {{ $t('javascript.modal.yes_attach') }}
          </button>
          <br>
          <slot name="footer">
            <small style="color: black;">
              {{ $t('javascript.modal.the_final_pdf') }}
            </small>
          </slot>

        </div>
      </div>
    </div>
  </div>
</template>


